export interface EmployeeSearchData {
  POST_ID: number;
  UNIT_LEVEL: number;
  UNIT_ID: number;
  DSGN_ID: number;
  EMP_ID: number;
  ORG_NAME: string;
  UNIT_NAME: string;
  FULL_NAME: string;
  USER_NAME: string;
}

export interface EmployeeSearch {
  messages: [];
  msgDisplay: number;
  data: EmployeeSearchData[];
  errors?: [];
}
